import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import format from '../../helpers/format'

const Styles = require('./TargetDateSeriesHoldingsLists.css')

@CSSModules(Styles, {allowMultiple:true})
export default class TargetDateSeriesHoldingsLists extends Component {
  static propTypes = {
    // the config for this set of IYV categories
    iyvConfigCategories: PropTypes.array.isRequired,
    // the target date series object
    targetDateSeries: PropTypes.object.isRequired,
  }
  constructor(props) {
    super(props)
  }

  render() {
    const { iyvConfigCategories, targetDateSeries } = this.props

    return (
      <div styleName='holding-lists'>
        {
          iyvConfigCategories.map((e, i) => {
            if (!e.fld) {
              return null
            }
            const holdingsCount = targetDateSeries.holdings[e.fld].count
            const holdingsList = targetDateSeries.holdings[e.fld].list
            return holdingsCount > 0 ?
              (
                <div styleName='holding-list' key={'holding-list-'+i}>
                  <div styleName='holding-list-icn-title-flex'>
                    {
                      e.icon ?
                        (
                          <img
                            src={e.icon}
                            alt={e.lbl}
                            styleName='holding-list-icn'
                          />
                        ) :
                        (
                          <div styleName='holding-list-no-icn'/>
                        )
                    }
                    <div styleName='holding-list-title'>
                      <div styleName='holding-list-title-label'>
                        Top {holdingsCount} holdings
                      </div>
                      <h3>
                        {e.lbl}
                      </h3>
                    </div>
                  </div>

                  <ol>
                    {
                      holdingsList.map((_e, _i) => {
                        return (
                          <li key={'holding-list-item-'+_i}>
                            <div styleName='holding-list-item'>
                              <div styleName='holding-list-item-title'>
                                {_e.standard_name}
                              </div>
                              <div>
                                {format.perc(_e.long_weight)}
                              </div>
                            </div>
                          </li>
                        )
                      })
                    }
                  </ol>
                </div>
              ) :
              null
          })
        }
      </div>
    )
  }
}